(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("clipboard"), require("prop-types"), require("react"), require("react-dom"));else if (typeof define === 'function' && define.amd) define(["clipboard", "prop-types", "react", "react-dom"], factory);else if (typeof exports === 'object') exports["ReactClipboard"] = factory(require("clipboard"), require("prop-types"), require("react"), require("react-dom"));else root["ReactClipboard"] = factory(root["ClipboardJS"], root["PropTypes"], root["React"], root["ReactDOM"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/
      var installedModules = {};
      /******/
      /******/ // The require function
      /******/
      function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/
        };
        /******/
        /******/ // Execute the module function
        /******/
        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/
        module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/
        return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/
      __webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/
      __webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/
      __webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/
      };
      /******/
      /******/ // define __esModule on exports
      /******/
      __webpack_require__.r = function (exports) {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
      /******/ // create a fake namespace object
      /******/ // mode & 1: value is a module id, require it
      /******/ // mode & 2: merge all properties of value into the ns
      /******/ // mode & 4: return value when already ns object
      /******/ // mode & 8|1: behave like require
      /******/
      __webpack_require__.t = function (value, mode) {
        /******/if (mode & 1) value = __webpack_require__(value);
        /******/
        if (mode & 8) return value;
        /******/
        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/
        var ns = Object.create(null);
        /******/
        __webpack_require__.r(ns);
        /******/
        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/
        if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
          return value[key];
        }.bind(null, key));
        /******/
        return ns;
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/
      __webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ? /******/function getDefault() {
          return module['default'];
        } : /******/function getModuleExports() {
          return module;
        };
        /******/
        __webpack_require__.d(getter, 'a', getter);
        /******/
        return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/
      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/
      __webpack_require__.p = "";
      /******/
      /******/
      /******/ // Load entry module and return exports
      /******/
      return __webpack_require__(__webpack_require__.s = "./index.js");
      /******/
    }
    /************************************************************************/
    /******/({
      /***/"./index.js":
      /*!******************!*\
        !*** ./index.js ***!
        \******************/
      /*! exports provided: default */
      /***/
      function indexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! react */"react");
        /* harmony import */
        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! react-dom */"react-dom");
        /* harmony import */
        var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! prop-types */"prop-types");
        /* harmony import */
        var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
        function _typeof(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === 'function') {
              ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
              }));
            }
            ownKeys.forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          }
          return target;
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }
        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }
          return _assertThisInitialized(self);
        }
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }
          return self;
        }
        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }
        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }
          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };
          return _setPrototypeOf(o, p);
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        var ClipboardButton = /*#__PURE__*/
        function (_React$Component) {
          _inherits(ClipboardButton, _React$Component);
          function ClipboardButton() {
            _classCallCheck(this, ClipboardButton);
            return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
          }
          _createClass(ClipboardButton, [{
            key: "propsWith",
            value: function propsWith(regexp) {
              var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var object = {};
              Object.keys(this.props).forEach(function (key) {
                if (key.search(regexp) !== -1) {
                  var objectKey = remove ? key.replace(regexp, '') : key;
                  object[objectKey] = this.props[key];
                }
              }, this);
              return object;
            }
          }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
              this.clipboard && this.clipboard.destroy();
            }
          }, {
            key: "componentDidMount",
            value: function componentDidMount() {
              // Support old API by trying to assign this.props.options first;
              var options = this.props.options || this.propsWith(/^option-/, true);
              var element = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this.element);
              if (!element) {
                return;
              }
              var Clipboard = __webpack_require__( /*! clipboard */"clipboard");
              this.clipboard = new Clipboard(element, options);
              var callbacks = this.propsWith(/^on/, true);
              Object.keys(callbacks).forEach(function (callback) {
                this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
              }, this);
            }
          }, {
            key: "render",
            value: function render() {
              var _this = this;
              var attributes = _objectSpread({
                title: this.props.title || '',
                type: this.getType(),
                className: this.props.className || '',
                style: this.props.style || {},
                ref: function ref(element) {
                  return _this.element = element;
                },
                onClick: this.props.onClick
              }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
              var Clipboard = __webpack_require__( /*! clipboard */"clipboard");
              if (!this.props.isVisibleWhenUnsupported && !Clipboard.isSupported()) {
                return null;
              }
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);
            }
          }, {
            key: "getType",
            value: function getType() {
              if (this.getComponent() === 'button' || this.getComponent() === 'input') {
                return this.props.type || 'button';
              } else {
                return undefined;
              }
            }
          }, {
            key: "getComponent",
            value: function getComponent() {
              return this.props.component || 'button';
            }
          }]);
          return ClipboardButton;
        }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
        _defineProperty(ClipboardButton, "propTypes", {
          options: function options(props, propName, componentName) {
            var options = props[propName];
            if (options && _typeof(options) !== 'object' || Array.isArray(options)) {
              return new Error("Invalid props '".concat(propName, "' supplied to '").concat(componentName, "'. ") + "'".concat(propName, "' is not an object."));
            }
            if (props['option-text'] !== undefined) {
              var optionText = props['option-text'];
              if (typeof optionText !== 'function') {
                return new Error("Invalid props 'option-text' supplied to '".concat(componentName, "'. ") + "'option-text' is not a function.");
              }
            }
          },
          title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
          type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
          className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
          style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
          component: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
          children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any
        });
        _defineProperty(ClipboardButton, "defaultProps", {
          isVisibleWhenUnsupported: true,
          onClick: function onClick() {}
          /* Returns a object with all props that fulfill a certain naming pattern
           *
           * @param {RegExp} regexp - Regular expression representing which pattern
           *                          you'll be searching for.
           * @param {Boolean} remove - Determines if the regular expression should be
           *                           removed when transmitting the key from the props
           *                           to the new object.
           *
           * e.g:
           *
           * // Considering:
           * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
           *
           * // *RegExps not using // so that this comment doesn't break up
           * this.propsWith(option-*, true); // returns {foo: 1}
           * this.propsWith(on*, true); // returns {Bar: 2}
           * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
           */
        });

        /* harmony default export */
        __webpack_exports__["default"] = ClipboardButton;

        /***/
      },

      /***/"clipboard":
      /*!********************************************************************************************************!*\
        !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
        \********************************************************************************************************/
      /*! no static exports found */
      /***/
      function clipboard(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;

        /***/
      },

      /***/"prop-types":
      /*!*********************************************************************************************************!*\
        !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
        \*********************************************************************************************************/
      /*! no static exports found */
      /***/
      function propTypes(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

        /***/
      },

      /***/"react":
      /*!**************************************************************************************!*\
        !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
        \**************************************************************************************/
      /*! no static exports found */
      /***/
      function react(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

        /***/
      },

      /***/"react-dom":
      /*!*****************************************************************************************************!*\
        !*** external {"root":"ReactDOM","amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom"} ***!
        \*****************************************************************************************************/
      /*! no static exports found */
      /***/
      function reactDom(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

        /***/
      }

      /******/
    })
  );
});